module.exports = __webpack_public_path__ + "img/user-square.11c4292d.svg";